import TabletIntroduction from '@App/pages/Tablet/Introduction/Introduction';
import MonitorIntroduction from '@App/pages/Monitor/Introduction/Introduction';

import './introduction.css';

function Introduction() {
  return (
    <main className="web-introduction">
      <TabletIntroduction enableKeyboard={false} />
      <MonitorIntroduction />
    </main>
  );
}

export default Introduction;
